import { render } from "./login-page-index.vue?vue&type=template&id=9fc080f2&scoped=true"
import script from "./login-page-index.vue?vue&type=script&lang=js"
export * from "./login-page-index.vue?vue&type=script&lang=js"

import "./login-page-index.vue?vue&type=style&index=0&id=9fc080f2&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fc080f2"]])

export default __exports__